import { InputNumber, Slider } from "antd";
import { useTranslation } from "react-i18next";

interface RangeInputProps
{
      label?: string;
      value: [number, number];
      min?: number;
      max?: number;
      onChange: (val: [number, number]) => void;
      disabled?: boolean
}

const RangeInput = ({
      label,
      value,
      min = 0,
      max = 100,
      onChange,
      disabled
}: RangeInputProps) =>
{
      const [minVal, maxVal] = value;
      const { t } = useTranslation();

      return (
            <div className="w-full mb-5">
                  {
                        label && <p className="text-sm mb-3 text-gray-300">{t(label)}</p>
                  }


                  <div className="w-full flex justify-between gap-4 items-center">
                        <InputNumber
                              min={min}
                              max={maxVal}
                              step={1}
                              value={minVal}
                              className="div-dropdown !w-[68px] min-w-[68px]"
                              placeholder="Min"
                              onChange={(val) =>
                              {
                                    if (val === null) return;
                                    onChange([val, maxVal]);
                              }}
                              disabled={disabled}
                        />

                        <Slider
                              className=" w-full"
                              range
                              min={min}
                              max={max}
                              step={1}
                              value={[minVal, maxVal]}
                              onChange={(val) => onChange(val as [number, number])}
                              disabled={disabled}
                        />

                        <InputNumber
                              min={minVal}
                              max={max}
                              step={1}
                              value={maxVal}
                              className="div-dropdown !w-[68px] min-w-[68px]"
                              placeholder="Max"
                              onChange={(val) =>
                              {
                                    if (val === null) return;
                                    onChange([minVal, val]);
                              }}
                              disabled={disabled}
                        />
                  </div>
            </div>
      );
};

export default RangeInput